import * as vdpUsedTypes from 'vdp-used/actions/vdpUsedActionTypes.js';
import VdpUsedModel from 'vdp-used/models/VdpUsedModel.js';

export default function vdpUsedReducer(state = new VdpUsedModel(), action) {
    switch (action.type) {
        case vdpUsedTypes.SET_VDP_USED:
            return action.vdpUsed;

        case vdpUsedTypes.INVALID_STATE:
            return state.set('invalidState', action.payload);

        default:
            return state;
    }
}
